<div
  id="acknowledge-product"
  *ngIf="
    exceptionResolution?.expanded &&
    !!exceptionResolution?.orderException?.productNumber
  "
>
  <p data-cy="acknowledgement-message-text">
    <ion-icon name="alert-circle-outline" class="alert-icon"></ion-icon
    >{{ exceptionResolution?.orderException?.errorMessage }}
  </p>
  <div class="product-row">
    <div class="exception-img">
      <img
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="!!thumbnailImageURL && !isOffline"
        [attr.data-cy]="
          'acknowledgement-product-' + product?.productNumber + '-image'
        "
        class="product-image"
      />
      <ion-icon
        name="restaurant"
        *ngIf="!thumbnailImageURL || isOffline"
        data-cy="acknowledgement-no-image-icon"
        class="product-image no-image"
      ></ion-icon>
    </div>

    <div class="product-information">
      <div
        class="brand"
        [attr.data-cy]="
          'acknowledgement-product-' + product?.productNumber + '-brand-text'
        "
      >
        {{ product?.summary?.brand }}
      </div>
      <div
        class="description"
        [attr.data-cy]="
          'acknowledgement-product-' +
          product?.productNumber +
          '-description-text'
        "
      >
        {{ product?.summary?.productDescTxtl | acronymTitleCase }}
      </div>
      <div
        class="other-product-information"
        [attr.data-cy]="
          'acknowledgement-product-' + product?.productNumber + '-info-text'
        "
      >
        <span>
          #{{ product?.productNumber }} <span class="border">|</span>
          {{ product?.summary?.salesPackSize }}
        </span>
      </div>
      <div>
        <div
          class="ordered-reserved"
          [attr.data-cy]="
            'acknowledgement-product-' +
            product?.productNumber +
            '-ordered-reserved-text'
          "
        >
          <span>{{ 'i18n.common.ordered' | translate }}:</span>
          {{ exceptionResolution?.orderItem?.unitsOrdered?.currentValue || 0 }}
          CS /
          {{ exceptionResolution?.orderItem?.eachesOrdered?.currentValue || 0 }}
          EA &nbsp; &nbsp;
          <span>{{ 'i18n.common.reserved' | translate }}:</span>
          {{ exceptionResolution?.orderItem?.unitsReserved || 0 }} CS /
          {{ exceptionResolution?.orderItem?.eachesReserved || 0 }} EA
        </div>
      </div>
    </div>

    <ion-button
      class="usf-fill-green-button"
      data-cy="confirm-acknowledgement-button"
      (click)="confirm()"
      >{{ 'i18n.common.confirm' | translate }}</ion-button
    >
  </div>
</div>

<div id="banner" *ngIf="!exceptionResolution?.expanded">
  <div class="banner-title" data-cy="banner-confirmed-title">
    {{ 'i18n.common.confirmed' | translate }}
  </div>
  <div
    class="exceptions-completed-product-info"
    *ngIf="!!exceptionResolution?.orderException?.productNumber"
  >
    <div class="exception-img">
      <img
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="!!thumbnailImageURL && !isOffline"
        [attr.data-cy]="
          'banner-acknowledgement-product-' + product?.productNumber + '-image'
        "
        class="product-image"
      />
      <ion-icon
        name="restaurant"
        *ngIf="!thumbnailImageURL || isOffline"
        data-cy="banner-no-image-icon"
        class="product-image no-image"
      ></ion-icon>
    </div>

    <div class="exceptions-completed-product-info-inner">
      <div
        class="brand-and-product-number"
        [attr.data-cy]="
          'banner-acknowledgement-product-' +
          product?.productNumber +
          '-brand-number-text'
        "
      >
        {{ product?.summary?.brand | acronymTitleCase }}
        <span class="border">|</span> #{{ product?.productNumber }}
      </div>
      <div
        class="product-description"
        [attr.data-cy]="
          'banner-acknowledgement-product-' +
          product?.productNumber +
          '-description-text'
        "
      >
        {{ product?.summary?.productDescTxtl | acronymTitleCase }}
      </div>
    </div>
  </div>
  <div
    class="exceptions-completed-product-info"
    *ngIf="!exceptionResolution?.orderException?.productNumber"
  >
    <div class="exceptions-completed-product-info-inner">
      <div
        class="order-number"
        [attr.data-cy]="
          'banner-acknowledgement-product-' +
          product?.productNumber +
          '-order-number-text'
        "
      >
        {{ 'i18n.orderExceptionsPage.orderNumber' | translate }}
        {{ orderNumber }}
      </div>
    </div>
  </div>
</div>

<div
  id="acknowledge-empty"
  *ngIf="
    exceptionResolution?.expanded &&
    !exceptionResolution?.orderException?.productNumber
  "
>
  <p data-cy="empty-acknowledgement-message-text">
    <ion-icon name="alert-circle-outline"></ion-icon>
    {{ exceptionResolution?.orderException?.errorMessage }}
  </p>
  <ion-button
    class="usf-fill-green-button"
    data-cy="confirm-error-acknowledgement-button"
    (click)="confirm()"
    >{{ 'i18n.common.confirm' | translate }}</ion-button
  >
</div>
